import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useUserRoleStore } from "entities/auth/stores/userRoleStore";
import { AdminRole } from "entities/auth/types";
import { useUpdateBrandMutation } from "entities/brands/mutations/useUpdateBrandMutation";
import React from "react";
import { useParams } from "react-router-dom";
import CustomBottomTooltip from "shared/components/CustomBottomTooltip";
import SecondarySwitch from "shared/components/Form/SecondarySwitch";
import { COLOR_GREY_9 } from "shared/theme/colors";
import { InfoCircleIcon } from "shared/theme/icons/InfoCircleIcon";
import { RepairIcon } from "shared/theme/icons/RepairIcon";
import { usePagesPage } from "../../context";
import ConfirmMaintenanceModal from "../ConfirmMaintenanceModal";
import { StyledBox } from "./styled";

const toggleLabel = "Maintenance Mode for Entire Brand";

const MaintenanceModeToggle = () => {
  const { id } = useParams();
  const brandId = String(id);
  const {
    brandDetails,
    brandMaintenanceModeModal,
    brandMaintenanceModeDescription,
  } = usePagesPage();
  const { roles } = useUserRoleStore();
  const isSuperAdmin = roles.includes(AdminRole.SuperAdmin);
  const { mutate: onUpdateBrandMutate, isPending } = useUpdateBrandMutation();

  const handleUpdateBrandDetails = async () => {
    if (isPending) return;

    const isBrandMaintenanceMode = !brandDetails?.isBrandMaintenanceMode;
    const brandMaintenanceModeDescriptionValue = brandDetails
      ?.brandMaintenanceModeDescription?.length
      ? ""
      : brandMaintenanceModeDescription?.input.value;

    const brand = {
      ...brandDetails,
      isBrandMaintenanceMode,
      brandMaintenanceModeDescription: brandMaintenanceModeDescriptionValue,
    };

    onUpdateBrandMutate(
      { brand, brandId },
      { onSuccess: brandMaintenanceModeModal.closeModal },
    );
  };

  const renderTooltip = () =>
    brandDetails?.brandMaintenanceModeDescription?.length ? (
      <CustomBottomTooltip title={brandMaintenanceModeDescription?.input.value}>
        <InfoCircleIcon />
      </CustomBottomTooltip>
    ) : null;

  return (
    <>
      <Box display="flex" columnGap={1} alignItems="center">
        {isSuperAdmin ? (
          <>
            <SecondarySwitch
              value={brandDetails?.isBrandMaintenanceMode ?? false}
              onChange={() =>
                brandDetails?.isBrandMaintenanceMode
                  ? handleUpdateBrandDetails()
                  : brandMaintenanceModeModal.openModal()
              }
              label={toggleLabel}
            />
            {renderTooltip()}
          </>
        ) : (
          brandDetails?.isBrandMaintenanceMode && (
            <>
              <Box display="flex" columnGap={1.5} alignItems="center">
                <StyledBox>
                  <RepairIcon />
                </StyledBox>
                <Typography
                  variant="bodyLMedium"
                  color={COLOR_GREY_9}
                  textTransform="uppercase"
                >
                  {toggleLabel}
                </Typography>
              </Box>
              {renderTooltip()}
            </>
          )
        )}
      </Box>
      <ConfirmMaintenanceModal
        title="Confirm Brand Maintenance Mode"
        subtitle="Are you sure you want to enable Maintenance Mode for the entire brand? All pages under this brand will become unavailable to users."
        isOpen={brandMaintenanceModeModal.isOpen}
        onCancel={brandMaintenanceModeModal.closeModal}
        onConfirm={handleUpdateBrandDetails}
        descriptionInput={brandMaintenanceModeDescription}
        isLoading={isPending}
      />
    </>
  );
};

export default MaintenanceModeToggle;
